<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" placeholder="搜索订单号,联系人,手机"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="商品">
              <a-select
                      showSearch
                      optionFilterProp="children"
                      v-model="queryParam.goods_id"
                      placeholder="选择商品"
                      allowClear
              >
                <a-select-option :key="option.id" v-for="option in goodsOptions" :value="option.id">{{option.title}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="状态">
              <a-select v-model="queryParam.status" placeholder="请选择"
                        allowClear >
                <a-select-option value="1">待付款</a-select-option>
                <a-select-option value="2">待发货/确认</a-select-option>
                <a-select-option value="3">待签收/使用</a-select-option>
                <a-select-option value="4">已完成</a-select-option>
                <a-select-option value="5">售后中</a-select-option>
                <a-select-option value="6">已关闭</a-select-option>
                <a-select-option value="2.1">待成团</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator">
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <!--<a-menu-item @click="setAllStatus(1)" key="1"><a-icon type="upload" />上架</a-menu-item>-->
          <!--<a-menu-item @click="setAllStatus(2)" key="2"><a-icon type="download" />下架</a-menu-item>-->
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作 <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <s-table
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
      :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
      :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >
      <span slot="goods" slot-scope="text,record">
        <div style="margin-bottom: 10px;padding-bottom: 10px; border-bottom: 1px solid #eee">订单号 {{record.code}}  </div>
        <div v-for="goods in record.items" style="margin-bottom: 10px ; padding-bottom: 10px; border-bottom: 1px solid #eee">
          <img style="width: 38px ; height: 38px; float: left" :src="goods.pic_url" />
          <div style="margin-left: 10px; float: left">
            {{goods.title}}
            <br/><span style="color: #999">{{goods.sku.sku_formart}}</span> x {{goods.count}}
            <br/>
          </div>
          <div class="cf"></div>
        </div>
        <div>
            <a-badge :status="record.status_data.class" :text="record.status_data.name" />
          <a-rate style="font-size: 16px; float: right;" @change="starChange(record)" v-model='record.star'/>
          <div class="cf"></div>
          </div>
      </span>
      <span slot="buyer" slot-scope="text,record">
        <template >
        <div>{{record.buyer_name}}({{record.user_name}})<br/>{{record.buyer_phone}}
        </div>
          </template>
      </span>
      <span slot="price" slot-scope="text,record">
        <template >
        <div><span class="hightlight">{{record.pay_price|price}}</span>元<br/>
          下单 {{record.create_time|timeFormat}}<br/>
          付款 {{record.pay_time|timeFormat}}
        </div>
        </template>
      </span>
      <span slot="action" slot-scope="text,record">
        <template >
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
        </template>
        <a-dropdown>
          <a class="ant-dropdown-link">
            更多 <a-icon type="down" />
          </a>
          <a-menu slot="overlay">
            <!--<a-menu-item>-->
              <!--<a  >分销配置</a>-->
            <!--</a-menu-item>-->
          </a-menu>
        </a-dropdown>
      </span>
    </s-table>
  </a-card>
</template>

<script>
  import STable from '@/components/table/'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import AInput from 'ant-design-vue/es/input/Input'
  import EditableCell from '@/components/EditableCell/'
  import moment from 'moment'

  import { getOrderList,getGoodsOptions,setOrderStar } from '@/api/order'
  export default {
    name: 'OrderList',
    components: {
      AInput,
      ATextarea,
      STable,
      EditableCell,
    },
    data () {
      return {
        visible: false,
        saveLoading:false,
        formData:{
          title:'',
          rules:[],
        },
        labelCol: {
//          xs: { span: 24 },
//          sm: { span: 5 },
          xs: { span: 24 },
          sm: { span: 2 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12 },
        },
        form: this.$form.createForm(this),
        mdl: {},

        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {
          keywords:'',
        },
        goodsOptions:[],
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '50px'
          },
          {
            title: '商品',
            dataIndex: 'goods',
            scopedSlots: { customRender: 'goods' },
          },
          {
            width:'150px',
            title: '买家',
            dataIndex: 'buyer_name',
            scopedSlots: { customRender: 'buyer' },
          },
          {
            title: '价格',
            width:'250px',
            dataIndex: 'pay_price',
            scopedSlots: { customRender: 'price' },
          },
          {
            title: '操作',
            dataIndex: 'action',
            width: '200px',
            scopedSlots: { customRender: 'action' },
          }
        ],
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          console.log('loadData');
          console.log(this.queryParam);
          this.queryParam.cate_id = 0;
          if(this.queryParam.cate_ids && this.queryParam.cate_ids.length) {
            this.queryParam.cate_id = [...this.queryParam.cate_ids].pop();
          }
          this.queryParam = Object.assign(this.queryParam,parameter);
          return getOrderList(this.queryParam)
            .then(res => {
              console.log('res');
              return res.data
            })
        },

        selectedRowKeys: [],
        selectedRows: [],
      }
    },
    computed:{
    },
    created(){
    },
    mounted(){
      let that = this;
      that.getGoodsOptions() ;
    },
    methods: {
      handleEdit(record){
          if(record.type=='shop'){
            const {href} = this.$router.resolve({name:'ShopOrderDetail',query:{id:record.id}});
            window.open(href, '_blank');
          }else{
            let {href} = this.$router.resolve({name:'OrderDetail',query:{id:record.id}});
            window.open(href, '_blank');
          }
      },
    // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh(false)
    },
      setAllStatus(status){
        let self = this;
        setGoodsAllStatus({
          ids:self.selectedRowKeys,
          status:status,
        })
                .then(res => {
                  self.$message.success('设置成功')
                  self.$refs.table.refresh(false)
                })
      },
      setStatus(goods_id,status){
        setGoodsStatus({
          id:goods_id,
          status:status,
        })
                .then(res => {
                  self.$message.success('设置成功')
                  self.$refs.table.refresh(false)
                })
      },
        starChange(record){
          console.log(record);
            setOrderStar({
                id:record.id,
                star:record.star,
            })
            .then(res => {
            })
        },
     // 删
    onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },
      sellerRewardDone(){
        this.sellerRewardVisible = false;
      },
      dealtownRewardDone(){
        this.dealtownRewardVisible = false;
      },
      getGoodsOptions(){
        let self = this;
        getGoodsOptions( ).then(res => {
          self.goodsOptions = res.data;
        }).catch(err =>{
          self.$message.error(err.data.msg)
        })
      },
    },
    watch: {
    }
  }
</script>
